export default "__VITE_ASSET__BF2G7UVb__"